export enum marketShareOperationType {
  'atingir o limite superior' = 1,
  'atingir o limite médio' = 2,
  'atingir o limite inferior' = 3,
  'manter' = 4,
  'aumentar vendas' = 5
}
